import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Visual wordmark for MyLegacyBridge: Fraunces, tracking, subtle MyLegacy (light) / Bridge (strong).
 * Accessibility: aria-label="MyLegacyBridge" — two spans render as one name visually (no space).
 */
export function BrandWordmark({ className, variant = 'navApp', as: Component = 'span', ...rest }) {
  const variants = {
    navLanding: 'brand-wordmark brand-wordmark--on-dark',
    navApp: 'brand-wordmark brand-wordmark--on-light',
    navFaq: 'brand-wordmark brand-wordmark--on-light',
    /** Tree / DNA nav — heritage green (text-primary) */
    treeNav: 'brand-wordmark brand-wordmark--on-primary',
    auth: 'brand-wordmark brand-wordmark--on-light text-2xl sm:text-[1.65rem] leading-tight',
    welcome: 'brand-wordmark brand-wordmark--on-light text-2xl sm:text-[1.65rem] leading-tight',
    /** App footer link row */
    footerOnDark: 'brand-wordmark brand-wordmark--footer-on-dark',
    footerOnLight: 'brand-wordmark brand-wordmark--footer-on-light',
    footerCopyrightDark: 'brand-wordmark brand-wordmark--footer-on-dark brand-wordmark--copyright',
    footerCopyrightLight: 'brand-wordmark brand-wordmark--footer-on-light brand-wordmark--copyright',
    pill: 'brand-wordmark brand-wordmark--on-dark brand-wordmark--pill',
    inline: 'brand-wordmark brand-wordmark--on-light brand-wordmark--inline',
    subtle: 'brand-wordmark brand-wordmark--on-light',
  };

  return (
    <Component
      className={cn('inline-flex items-baseline gap-0', variants[variant] || variants.navApp, className)}
      aria-label="MyLegacyBridge"
      {...rest}
    >
      <span className="brand-wordmark__my">MyLegacy</span>
      <span className="brand-wordmark__bridge">Bridge</span>
    </Component>
  );
}

export default BrandWordmark;
